import DeleteIcon from "@mui/icons-material/Delete";
import { Grid, IconButton, Stack } from "@mui/material";
import { FormikProps } from "formik";

import { IOptionItem } from "@/common/components/fields/formik/formik-autocomplete/FormikAutocomplete.types";
import { FormikAutocompleteSelect } from "@/common/components/fields/formik/formik-autocomplete/FormikAutocompleteSelect";
import { FormikDatePicker } from "@/common/components/fields/formik/formik-date-picker/FormikDatePicker";
import { CounselorDutyPreferencesFormValues } from "@/pages/system-settings/tabs/counselors/pages/counselor-detail/pages/duty-preferences/CounselorDutyPreferences.types";
import { useTranslation } from "@/translations";

interface Props {
  formik: FormikProps<CounselorDutyPreferencesFormValues>;
  index: number;
  dutyTypeOptions: IOptionItem[];
  onDelete: () => void;
}

export function BlockedPeriodRow({ formik, index, dutyTypeOptions, onDelete }: Props) {
  const { t } = useTranslation();

  return (
    <Stack direction={{ xs: "column", md: "row" }} gap={2} alignItems="flex-start">
      <Grid container spacing={2} sx={{ flex: 1, width: "100%" }}>
        <Grid size={{ xs: 12, md: 6 }}>
          <FormikAutocompleteSelect
            formik={formik}
            path={`blockedPeriods.${index}.dutyType`}
            label={t("counselors.dutyPreferences.blockedPeriods.dutyType")}
            options={dutyTypeOptions}
            required
          />
        </Grid>
        <Grid size={{ xs: 6, md: 3 }}>
          <FormikDatePicker
            formik={formik}
            path={`blockedPeriods.${index}.from`}
            label={t("counselors.dutyPreferences.blockedPeriods.from")}
            required
          />
        </Grid>
        <Grid size={{ xs: 6, md: 3 }}>
          <FormikDatePicker
            formik={formik}
            path={`blockedPeriods.${index}.to`}
            label={t("counselors.dutyPreferences.blockedPeriods.to")}
            required
          />
        </Grid>
      </Grid>
      <IconButton
        onClick={onDelete}
        size="medium"
        color="default"
        aria-label={t("counselors.dutyPreferences.blockedPeriods.deleteRow")}
      >
        <DeleteIcon />
      </IconButton>
    </Stack>
  );
}
